import React, { useState } from 'react';
import { Tabs, Tab, Box, Typography, Paper } from '@mui/material';

import { useTranslation } from 'react-i18next';
import FinalReviewPage from '../Review';

/* STRANA ZA PROVERU PREGLEDANIH RADOVA */
/* STRANA GDE SE NALAZE 2 TABA U ZAVINOSTI KOJU PROVERU ZELIMO  ( PO SKOLI/PO RAZREDIMA) */
const FinalVerifyReviews = () => {
  const [activeTab, setActiveTab] = useState(0);
  const { t } = useTranslation();

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ width: '100%', padding: '20px' }}>
      {/* Naslov stranice */}
      <Typography
        variant="h4"
        align="center"
        gutterBottom
        sx={{
          fontWeight: 'bold',
          color: '#1976d2',
          marginBottom: '20px'
        }}
      >
        {t('review.gradesTitle')}
      </Typography>

      {/* Tab content */}
      <Paper
        elevation={4}
        sx={{
          marginTop: '20px',
          padding: '20px',
          borderRadius: '16px',
          minHeight: '60vh',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)'
        }}
      >
        {activeTab === 0 && <FinalReviewPage />}
      </Paper>
    </Box>
  );
};

export default FinalVerifyReviews;
